<div class="empty-state d-flex align-items-center pt-5">
    <div class="m-auto text-center mw250">
        <div class="icon-box"><ion-icon [src]="img"></ion-icon></div>
        <p>{{title}}</p>
        <div class="sub-title">
            {{subtitle}}
        </div>
    </div>
</div>